module.exports = "//static.hsappstatic.net/salesImages/static-1.403/crm-images/required_deal_stage_properties.svg"